import Base from 'front/components/Base/Base';
import * as _ from 'underscore';

import {VIEWPORT_EVENTS} from '../../../constants/Constants';
import './Content.less';

const Selectors = {
    el: '.IndexContent',
    illustrations: '.IndexIllustrations',
    animations: '.IndexAnimations',
    storyboards: '.IndexStoryboards',
    navigation: '.IndexContent-leftItem'
};

const BindFunctions = [
    'resize',
    'scroll',
    'onClickNav'
];

export default class Content extends Base {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.navigation}`]: this.onClickNav
        };
    }

    constructor() {
        super({el: Selectors.el});
        _.bindAll(this, BindFunctions);

        this.resize();
        $(window).on(VIEWPORT_EVENTS.resize, this.resize);

        this.scroll();
        $(window).on(VIEWPORT_EVENTS.scroll, this.scroll);
    }

    resize() {
        this.posIllustrations = $(Selectors.el)[0].offsetTop;
        this.posAnimations = this.posIllustrations + this.$(Selectors.illustrations)[0].offsetHeight - 40;
        this.posStoryboards = this.posAnimations + this.$(Selectors.animations)[0].offsetHeight - 40;
    }

    scroll() {
        const posTop = (window.pageYOffset !== undefined) ?
            window.pageYOffset :
            (document.documentElement || document.body.parentNode || document.body).scrollTop;

        if (posTop <= this.posAnimations) {
            this.$(Selectors.navigation).removeClass('active');
            this.$(Selectors.navigation).eq(0)
                .addClass('active');
        } else if (posTop > this.posAnimations && posTop <= this.posStoryboards) {
            this.$(Selectors.navigation).removeClass('active');
            this.$(Selectors.navigation).eq(1)
                .addClass('active');
        } else if (posTop > this.posStoryboards) {
            this.$(Selectors.navigation).removeClass('active');
            this.$(Selectors.navigation).eq(2)
                .addClass('active');
        }
    }

    onClickNav(e) {
        e.preventDefault();

        let id = $(e.currentTarget)[0].hash;
        let target = (id === '#illustrations') ? this.posIllustrations - 60 : (id === '#animations')
            ? this.posAnimations + 30 : this.posStoryboards + 60;

        app.els.$htmlBody.animate({
            scrollTop: target
        }, 500);
    }
}
